import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

/**
 * The small "Pro" mark beside something the Free plan does not include — a
 * sidebar row, a period preset. Monochrome and quiet: it labels, it does not
 * shout; the unlock prompt is where the page asks.
 */
export function ProTag({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <span
      title={t('FREE_PLAN.PRO_TAG_TITLE')}
      data-testid="pro-tag"
      className={cn(
        'inline-flex shrink-0 items-center rounded-full border px-1.5 py-px text-[10px] leading-4 font-medium text-muted-foreground',
        className,
      )}
    >
      {t('FREE_PLAN.PRO')}
    </span>
  );
}
